import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { isNonEmptyArray } from "@cayuse/shared-react.utils.type-checks";
import { isEqual } from "lodash";

import { hydrateColumnHeaders } from "utils";

const emptyArray = [];

export const formColumnHeadersSelector = type => state => state.tenant.formColumnHeaders[type] ?? emptyArray;

export const useColumnHeaders = (type, {
	defaultColumnHeaders: incomingDefaultColumnHeaders
} = {}) => {
	const prevIncomingDefaultColumnHeaders = useRef([]);
	const [ defaultColumnHeaders, setDefaultColumnHeaders ] = useState([]);

	const columnHeaders = useSelector(formColumnHeadersSelector(type));

	const hasColumnHeaders = isNonEmptyArray(columnHeaders);
	const hasDefaultColumnHeaders = isNonEmptyArray(incomingDefaultColumnHeaders);
	const dashboardColumnHeaders = useMemo(() => {
		return hasColumnHeaders
			? columnHeaders.filter(({ reportOnly }) => reportOnly !== true)
			: [];
	}, [ hasColumnHeaders, columnHeaders ]);

	useEffect(() => {
		if (isEqual(prevIncomingDefaultColumnHeaders.current, incomingDefaultColumnHeaders)) {
			return;
		}

		const defaultColumnHeaders = hasColumnHeaders && hasDefaultColumnHeaders
			? hydrateColumnHeaders(incomingDefaultColumnHeaders, columnHeaders)
			: incomingDefaultColumnHeaders || [];

		setDefaultColumnHeaders(defaultColumnHeaders);
		prevIncomingDefaultColumnHeaders.current = incomingDefaultColumnHeaders;
	}, [ hasColumnHeaders, hasDefaultColumnHeaders, incomingDefaultColumnHeaders, columnHeaders ]);

	return {
		columnHeaders,
		defaultColumnHeaders,
		dashboardColumnHeaders
	};
};
